const AccountSectionWrapper = ({
  children,
  className = "",
  title,
  buttonText,
  buttonIcon = "edit_white.svg", // Default icon if none provided
  onButtonClick,
}) => {
  return (
    <div className={`account-section-wrapper ${className}`}>
      <div className="account-section-header">
        <h3 className="account-section-title">{title}</h3>
        {/* Only render button if onButtonClick is provided */}
        {onButtonClick && (
          <button className="account-section-button" onClick={onButtonClick}>
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/${buttonIcon}`}
              alt={buttonText || "Action"}
              className="button-icon"
            />
            {buttonText && <b>{buttonText}</b>}
          </button>
        )}
      </div>
      {children}
    </div>
  );
};

export default AccountSectionWrapper;
